import { Button, Input, Select, TableProps } from "antd";
import { useParams } from "react-router-dom";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import StatusItem from "../../../../components/common/StatusItem";
import CustomTable from "../../../../components/ui/CustomTable";
import { AllContractParams } from "../../../../features/organization/contractual/JobDetails/jobDetails.type";
import { useGetAllContractHistoryQuery } from "../../../../features/organization/contractual/JobDetails/jobDetailsApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import useTable from "../../../../hooks/useTable";
import { formatDate } from "../../../../lib/time";
import { countParPageSerialNumber } from "../../../../utils/number";
import { capitalize, valueOrNa } from "../../../../utils/string";
import {
  addKeyInArray,
  selectArrayOption,
  selectSearchOption,
} from "../../../../utils/utils";
import ManageRenewContract from "./ManageRenewContract";

export const STATUSES = [
  {
    label: "Upcoming",
    value: "upcoming",
    className: "status-warning rounded-lg",
  },
  {
    label: "Active",
    value: "active",
    className: "status-success rounded-lg",
  },
  {
    label: "Completed",
    value: "completed",
    className: " status-link  rounded-lg",
  },
];
const Contract = () => {
  const { id } = useParams();
  const { open, handleOpen, handleClose } = useModal();
  const {
    page,
    limit,
    filter,
    keyword,
    handleLimit,
    handleSearch,
    handleFilter,
    handlePagination,
  } = useTable<AllContractParams>();

  const { data, isFetching, isLoading, isError, error } =
    useGetAllContractHistoryQuery(
      {
        arg: {
          params: {
            ...filter,
            search: keyword,
          },
        },
        id: Number(id),
      },
      {
        skip: !id,
      }
    );

  useError(isError, error, "Failed to fetch contract history data");

  const columns: TableProps<any>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Contact ID",
      dataIndex: "contract_id",
      render: (val) => valueOrNa(val),
    },
    {
      align: "center",
      title: "Period",
      render: (record: any) =>
        `${
          record?.contract_start_date
            ? formatDate(record?.contract_start_date, "DD MMM, YYYY")
            : ""
        } – ${
          record?.contract_end_date ? formatDate(record?.contract_end_date) : ""
        }`,
    },
    {
      title: "Duration",
      dataIndex: "contract_months",
      align: "center",
      render: (val: number) => <span>{val ? `${val} Months` : "n/a"}</span>,
    },
    {
      title: "Salary Slab",
      dataIndex: "salary_slab",
      render: (val) => valueOrNa(val?.slab_name),
    },
    {
      title: "Payment Type",
      align: "center",
      dataIndex: "payment_type",
      render: (val) => capitalize(val || "n/a"),
    },
    // {
    //   title: "KPI Group Linked",
    //   dataIndex: "kpi_group_linked",
    //   render: (val) => valueOrNa(val),
    // },
    {
      align: "center",
      title: "Status",
      dataIndex: "computed_status",
      render: (val) => <StatusItem value={val} list={STATUSES} />,
    },
  ];

  return (
    <>
      <CustomTable
        loading={isLoading || isFetching}
        limit={limit}
        page={page}
        columns={columns}
        total={data?.data.total}
        dataSource={addKeyInArray(data?.data?.contracts)}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        filterSection={
          <>
            <Input
              suffix={<SearchIcon />}
              placeholder="Search"
              style={{ minWidth: 170, maxWidth: 180 }}
              onChange={(val) => handleSearch(val)}
              allowClear
            />

            <Select
              allowClear
              showSearch
              placeholder="Status"
              className="min-w-[90px]"
              rootClassName="icon-gray"
              popupMatchSelectWidth={120}
              suffixIcon={<SelectDownIcon />}
              filterOption={selectSearchOption}
              options={selectArrayOption(STATUSES, "label", "value")}
              onChange={(value) => handleFilter("status", value)}
            />

            <Button
              type="primary"
              color="primary"
              onClick={() => handleOpen({ type: "ADD" })}
            >
              Renew Contract
            </Button>
          </>
        }
      />

      <ManageRenewContract
        type={open.type}
        handleClose={handleClose}
        open={open.open && open.type === "ADD"}
      />
    </>
  );
};

export default Contract;
